window.Helpers = new class {
	constructor() {
		this.loadedScripts = new Map();
	}

	throttle(func, wait, option = { leading: true, trailing: true }) {
		let timeout = null;
		let lastCallContext = null;
		let lastCallArgs = null;

		const later = () => {
			if (option.trailing && lastCallArgs) {
				func.apply(lastCallContext, lastCallArgs);
				lastCallContext = null;
				lastCallArgs = null;
				timeout = setTimeout(later, wait);
			} else {
				timeout = null;
			}
		};

		return function (...args) {
			if (timeout) {
				lastCallContext = this;
				lastCallArgs = args;
				return;
			}
			if (option.leading) {
				func.apply(this, args);
			} else {
				lastCallContext = this;
				lastCallArgs = args;
			}

			timeout = setTimeout(later, wait);
		};
	}

	debounce(func, delay) {
		let timeoutId;

		return function (...args) {
			clearTimeout(timeoutId);

			timeoutId = setTimeout(() => {
				func.apply(this, args);
			}, delay);
		};
	}

	loadScript(url) {
		if (this.loadedScripts.has(url)) {
			return this.loadedScripts.get(url);
		}

		const promise = new Promise((resolve, reject) => {
			const script = document.createElement('script');
			script.src = url;
			script.onload = () => resolve(script);
			script.onerror = () => reject(new Error(`Script load error for ${url}`));
			document.head.appendChild(script);
		});

		this.loadedScripts.set(url, promise);

		return promise;
	}

	loadStyle(url) {
		// check if stylesheet is already loaded
		const styles = document.querySelectorAll('link');
		const isLoaded = Array.from(styles).some(style => style.href === url);

		if (isLoaded) {
			return Promise.resolve();
		}

		return new Promise((resolve, reject) => {
			const link = document.createElement('link');
			link.rel = 'stylesheet';
			link.href = url;
			link.onload = () => resolve(link);
			link.onerror = () => reject(new Error(`Style load error for ${url}`));
			document.head.appendChild(link);
		});
	}

	postponeExecution(func, force = false) {

		if (force) {
			func();
			return;
		}

		const handler = (event) => {
			// Remove the event listeners
			window.removeEventListener('click', handler);
			window.removeEventListener('keypress', handler);
			window.removeEventListener('scroll', handler);
			window.removeEventListener('mousemove', handler);

			// Execute the function
			func(event);
		};

		// Add the event listeners
		window.addEventListener('click', handler, { once: true });
		window.addEventListener('keypress', handler, { once: true });
		window.addEventListener('scroll', handler, { once: true });
		window.addEventListener('mousemove', handler, { once: true });
	}

	// check if section in viewport
	inViewport(element) {
		if (Array.isArray(element)) {
			return element.some(el => this.inViewport(el));
		}

		const rect = element.getBoundingClientRect();

		return (
			rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
			rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
			rect.bottom > 0 &&
			rect.right > 0
		);
	}

	isIOS() {
		return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
	}
}

